export function toNumber(v) {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string") {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

export function normalizeDateString(raw) {
  if (!raw) return null;
  return String(raw).includes("T") ? String(raw) : String(raw).replace(" ", "T");
}

export function parseDate(raw) {
  const norm = normalizeDateString(raw);
  if (!norm) return null;
  const d = new Date(norm);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function formatDate(raw) {
  const d = parseDate(raw);
  if (!d) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
}

export function formatDateTime(raw) {
  const d = parseDate(raw);
  if (!d) return "—";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function truncate(text, max) {
  const t = String(text || "");
  return t.length > max ? t.slice(0, max) + "…" : t;
}

export function statusToKey(raw) {
  if (!raw) return "Submitted";

  const s = String(raw).trim().toLowerCase();

  switch (s) {
    case "submitted":
      return "Submitted";

    case "in review":
    case "review in progress":
      return "In Review";

    case "approved":
    case "approved - pending sponsor approval":
    case "approved - pending implementation":
      return "Approved";

    case "development in progress":
    case "in development":
      return "In Development";

    case "completed":
      return "Completed";

    case "denied":
    case "rejected":
      return "Denied";

    default:
      return "Submitted";
  }
}

export function statusDotClass(statusKey) {
  switch (statusKey) {
    case "Submitted":
      return "bi-dot is-submitted";
    case "In Review":
      return "bi-dot is-review";
    case "Approved":
      return "bi-dot is-approved";
    case "In Development":
      return "bi-dot is-dev";
    case "Completed":
      return "bi-dot is-completed";
    case "Denied":
      return "bi-dot is-denied";
    default:
      return "bi-dot";
  }
}

export function pickApiUrl(apiConfig) {
  const local = apiConfig?.localProxyUrl;
  const remote = apiConfig?.remoteUrl;

  const isLocalHost =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  return isLocalHost && local ? local : remote;
}
